module.exports = __webpack_public_path__ + "img/icon-edit.56ee7430.svg";